import React from "react";
import { connect } from "react-redux";
import { Loader } from "../../../../../core/atoms";
import ProfileGrid from "../../../../../core/organisms/profileGrid/profileGrid";
import { MatchState } from "../../../../../shared/helpers/reduxHelpers";

import "./aboutProfiles.scss";

interface StateProps {
  teamProfiles: IState<IAboutTeamProfiles<IUserPublic>>;
}

type Props = StateProps;

const AboutProfilesComponent = ({ teamProfiles }: Props) => {
  return (
    <div className="about-team-profiles width-wrapper">
      <div className="column is-8-tablet is-offset-4-tablet is-9-desktop is-offset-3-desktop">
        {MatchState(teamProfiles, {
          ok: () => {
            const profiles = teamProfiles.data.senior.concat(teamProfiles.data.team);
            return <ProfileGrid profiles={profiles} />;
          },
          pending: () => <Loader />,
          error: () => <p>Something went wrong when fetching profiles. Please try again.</p>,
        })}
      </div>
    </div>
  );
};

const stateToProps = (state: IWebStoreState): StateProps => ({
  teamProfiles: state.settings.data.teamProfiles,
});

export const AboutProfiles = connect<StateProps, void, {}>(stateToProps, null)(AboutProfilesComponent);
